export const enum ToastVariant {
  Success = "success",
  Error = "error",
  Info = "info",
  Warning = "warning",
}